import { useMutation, useQueryClient } from '@tanstack/react-query';
import { acknowledgeScheduledDeployment } from 'Services';
import { ScheduledDeployment } from 'Hooks/query-hooks/scheduled-deployment/useGetScheduledDeployment';
import { ReactQueryError } from '@brighterion/types/react-query';
import {
    RQ_ALL_DEPLOYMENTS,
    RQ_GLOBAL_RULES,
    RQ_MERCHANT_OVERRIDES,
    RQ_PARAMETERS,
    RQ_SCHEDULED_DEPLOYMENT
} from 'Utils';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';

const useAcknowledgeScheduledDeployment = () => {
    const queryClient = useQueryClient();
    const { templateRepositoryId } = useTemplateStore.getState().template;

    const invalidateQueries = () => {
        queryClient.invalidateQueries([RQ_GLOBAL_RULES, templateRepositoryId]);
        queryClient.invalidateQueries([RQ_ALL_DEPLOYMENTS]);
        queryClient.invalidateQueries([RQ_SCHEDULED_DEPLOYMENT]);
        queryClient.invalidateQueries([RQ_PARAMETERS]);
        queryClient.invalidateQueries([RQ_MERCHANT_OVERRIDES]);
    };

    return useMutation<ScheduledDeployment, ReactQueryError>({
        mutationFn: async () => {
            const data = await acknowledgeScheduledDeployment();
            return data;
        },
        retry: (failureCount, error) => {
            if (failureCount > 2 || error.response?.status === 404) {
                return false;
            }
            return true;
        },
        onSettled: () => {
            invalidateQueries();
        }
    });
};

export default useAcknowledgeScheduledDeployment;
